module.exports = __webpack_public_path__ + "images/emoji/beer.ce36c3ef882914e9dc74.png";